import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { features as accountFeatures } from "../../mockData/accountFeatures";
import { IAccountFeature } from "../../models/IAccountFeature.model";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import { accountTypes } from "../../utils/constants";
import InfoPopup from "../InfoPopup";
import DownloadIcon from "../../assets/icons/DownloadIcon";
import { handleDownload } from "../../utils/helpers";

function AccountTypeInfo(props: any) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [accountDetails, setAccountDetails] = useState<IAccountFeature>();

  const [comingSoonPopup, setComingSoonPopup] = useState<boolean>(false);

  const setAccountTypeToDisplay = () => {
    switch (props.accountType.toLowerCase()) {
      case accountTypes.current:
        setAccountDetails(accountFeatures.currentAccountDetails);
        break;
      case accountTypes.jointCurrent:
        setAccountDetails(accountFeatures.jointCurrentAccountDetails);
        break;
      case accountTypes.domiciliaryCurrent:
        setAccountDetails(accountFeatures.domicillaryCurrentAccountDetails);
        break;
      case accountTypes.swiftSavings:
        setAccountDetails(accountFeatures.swiftSavingsAccountDetails);
        break;
      case accountTypes.regularSavings:
        setAccountDetails(accountFeatures.savingsAccountDetails);
        break;
      case accountTypes.minorSavings:
        setAccountDetails(accountFeatures.minorSavingsAccountDetails);
        break;
      case accountTypes.jointSavings:
        setAccountDetails(accountFeatures.jointSavingsAccountDetails);
        break;
      case accountTypes.domiciliarySavings:
        setAccountDetails(accountFeatures.domiciliarySavingsAccountDetails);
        break;
    }
  };

  const navigateToOpenAccount = () => {
    // if(props.accountType.toLowerCase() === 'minor savings'){
    //     setComingSoonPopup(true)
    //     return
    // }
    let accountStatus = localStorage.getItem("accountStatus");
    if (accountStatus === "existing") {
      dispatch(setAccountOpeningStep("ex-bvn-validation"));
    } else {
      dispatch(setAccountOpeningStep("bvn-validation"));
    }
    navigate("/open-account");
  };

  useEffect(() => {
    setAccountTypeToDisplay();
  }, [props]);

  return (
    <div>
      <InfoPopup
        showPopup={comingSoonPopup}
        setComingSoonPopup={setComingSoonPopup}
        dismisButtonText="okay"
        popupText="This feature is coming soon....."
      />
      <div>
        <div className=" row mx-auto  bg-transparent mt-4  p-2 displayTray-title ">
          <div className="col-lg-4 p-2 text-lg-left medium-bold-texts text-capitalize">
            {props.accountType}{" "}
            {props.accountType.toLowerCase() === "swift savings"
              ? "(Tier 1)"
              : ""}
          </div>
          <div className="col-lg-4 py-md-3">
            <button
              className="btn btn-filled-red mt-2  float-lg-right  text-nowrap"
              onClick={navigateToOpenAccount}
            >
              Open Account
            </button>
          </div>
        </div>
        <div className="row mx-auto d-flex justify-content-between d-md-none d-lg-flex">
          <article className="col-lg-6 display-Tray px-0 mt-4">
            <div className=" small-label-texts text-lg-left">Features</div>

            {accountDetails
              ? accountDetails.features.map((feature) => {
                  return (
                    <div
                      key={feature.id}
                      className=" small-light-texts text-lg-left py-2"
                    >
                      <span className="bullets mr-1"></span> {feature.text}
                    </div>
                  );
                })
              : null}
          </article>
          <article className="col-lg-6 px-0 mt-4">
            <div className=" small-label-texts text-lg-left">Requirements</div>
            {accountDetails
              ? accountDetails.requirements.map((requirement) => {
                  return (
                    <div
                      key={requirement.id}
                      className=" small-light-texts text-lg-left py-2"
                    >
                      <span className="bullets mr-1"></span> {requirement.text}{" "}
                      {requirement.text.includes("references") && (
                        <u
                          className="cursor-pointer"
                          onClick={() =>
                            handleDownload(
                              "/assets/pdf/Updated_Altbank_Reference_Form.pdf",
                              "Reference_Form.pdf"
                            )
                          }
                        >
                          Download Reference Form{" "}
                          <DownloadIcon width="2rem" height="2rem" />
                        </u>
                      )}
                    </div>
                  );
                })
              : null}
          </article>
        </div>
      </div>
    </div>
  );
}

export default AccountTypeInfo;
